import {AppState} from '@app/context/context';

export interface SelectClientEvent {
    selectedClient: {
        client: string;
        name: string;
        isSelected: boolean;
    };
}

export function emitSelectClient(
    setState: React.Dispatch<React.SetStateAction<AppState>>,
    event: SelectClientEvent
) {
    setState((prevState) => {
        return {
            ...prevState,
            selectedClient: event.selectedClient
        };
    });
}
